module.exports = __webpack_public_path__ + "ffc851e6be2ba03ef8d7600d48e12766.svg";